import { Button } from "@aircall/tractor";

import { SpeedButtonProps } from "./SpeedButton.decl";

export function SpeedButton({
  children,
  isActive,
  onClick,
  disabled = false,
}: SpeedButtonProps) {
  return (
    <Button
      onClick={onClick}
      mode={isActive ? "outline" : "ghost"}
      variant="secondary"
      data-test="speed-button"
      size="small"
      disabled={disabled}
    >
      {children}
    </Button>
  );
}
